import { Stack, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React from 'react';
import CustomModal from '../CustomModal';

const Footer = () => {

    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);

    const styles = {
        outer: {
            root: {
                backgroundColor: "white",
                borderTop: "1px solid #DADADA",
                fontSize: 12,
                minHeight: 52
            }
        },
        text: { root: { cursor: "pointer" } }
    };

    return <>

        <Stack as="footer" horizontalAlign="center" styles={styles.outer} verticalAlign="center">
            <Text onClick={showModal} styles={styles.text}>Mentions légales</Text>
        </Stack>

        <CustomModal
            isOpen={isModalOpen}
            onDismiss={hideModal}
            title="Mentions légales"
        >
            <Text block>Le présent site internet accessible à l’adresse <Text styles={{ root: { textDecoration: "underline", whiteSpace: "nowrap" } }}>https://espacepersonnel.eiffage-immobilier.com</Text> (ci-après désigné le "Site") est édité par la société Eiffage Immobilier.</Text>
            <br />
            <Text block variant="xxLarge">Identification</Text>
            <Text block>
                Eiffage Immobilier<br />
                11 place de l’Europe<br />
                CS 50570<br />
                78140 Vélizy-Villacoublay<br />
                Téléphone : +33 (0)1 34 65 89 89<br />
                SAS au capital de 75 000 Euros, immatriculée au RCS de Versailles sous le numéro 314 527 649.
            </Text>
            <br />
            <Text block variant="xxLarge">Publication</Text>
            <Text block>Directeur de publication : Frédéric Vullierme, directeur datas et process</Text>
            <br />
            <Text block variant="xxLarge">Hébergement</Text>
            <Text block>
                Le site est hébergé par la société GROUPE OCI SAS, immatriculée au RCS de Strasbourg sous le numéro 502 770 118.<br />
                Siège social : 2 rue Ampère, 67450 Mundolsheim, France<br />
                Téléphone : + 33 (0)9 69 39 40 60
            </Text>
            <br />
            <Text block variant="xxLarge">Conditions générales d’utilisation</Text>
            <Text block>Les règles de fonctionnement et d’utilisation du Site sont accessibles sur la page des <a href="https://www.eiffage-immobilier.fr/conditions-generales-utilisation" target="_blank" rel="noreferrer">conditions générales d’utilisation</a>. Le fait d’accéder au Site et de naviguer sur le Site constitue une acceptation sans réserve desdites conditions.</Text>
            <br />
            <Text block variant="xxLarge">Politique de confidentialité</Text>
            <Text block>La politique de confidentialité des données personnelles mise en place par la société Eiffage Immobilier est <a href="https://www.eiffage-immobilier.fr/politique-confidentialite" target="_blank" rel="noreferrer">accessible sur cette page</a>.</Text>
        </CustomModal>

    </>;

};

export default Footer;